module.exports = __webpack_public_path__ + "static/img/video-thumbnail.8b515073.svg";